module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-toast-提示.0b1c0.png";